<template>
    <div>
        <p class="body-semibold">{{ t("profile.collaboration.documents.title") }}</p>
        <p class="body-small text-ink-muted mt-1">{{ t("profile.collaboration.documents.description") }}</p>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
